// Firebase SDK - only Auth is actively used
// Storage uses GCS directly via signed URLs from backend
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import type { Analytics } from "firebase/analytics";

// Which pool the SPA signs in to is the stack's, not the build's: the frontend
// serves /runtime-config.js from a ConfigMap (charts/valuepath-stack/templates/
// frontend.yaml), loaded by index.html before this bundle. No runtime config —
// local dev — means the shared stacks pool.
import { firebaseConfig as stacksConfig } from './firebase.config.stacks';

const runtimeConfig = window.__VP_CONFIG__?.firebase;
const firebaseConfig = runtimeConfig ?? stacksConfig;

console.log(`🔥 Firebase config: ${runtimeConfig ? 'runtime' : 'built-in stacks default'}`);
console.log(`🎯 Project: ${firebaseConfig.projectId}`);

// Initialize Firebase app and auth immediately (needed for auth state)
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

// Lazy-loaded Firebase services - cached after first load
let _analytics: Analytics | null = null;

// Lazy getter for Analytics
export async function getAnalytics(): Promise<Analytics> {
  if (!_analytics) {
    const { getAnalytics } = await import("firebase/analytics");
    _analytics = getAnalytics(app);
  }
  return _analytics;
}

export { app, auth, firebaseConfig };